<template>
  <div class="chart fund-saving-plan-chart">
    <div class="chartinner">
      <svg
        height="160"
        width="160"
        viewBox="0 0 160 160"
      >
        <g
          v-for="(value, index) in percentagesPie"
          :key="index"
        >
          <circle
            :cx="cx"
            :cy="cy"
            :r="radius"
            :stroke="colorsPie[index]"
            :stroke-width="strokeWidth"
            :stroke-dasharray="adjustedCircumference(value)"
            :stroke-dashoffset="calculateStrokeDashOffset(value, circumference)"
            :transform="returnCircleTransformValue(index)"
            fill="transparent"
          />
          <text />
        </g>
      </svg>
    </div>
    <div class="data">
      <h4 class="title">
        {{ title }}
      </h4>
      <div class="legends">
        <div
          v-for="(label, index) in labels"
          :key="index"
          class="legend"
        >
          <span
            class="color"
            :style="{backgroundColor: colors[index]}"
          />
          <div class="label">
            <p class="number">
              {{ hasNoThemes
                ? index == percentages.length - 1 ? 100: 0
                : Math.round(10 * percentages[index]) / 10 }}%
            </p>
            <span class="text">
              {{ label }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FundSavingPlanChartNew',
  props: {
    labelsAndValues: {
      type: Array,
      default: () => ([]),
    },
    hasNoThemes: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      angleOffset: 90,
      colors: ['#E5E3D3', '#8CCDE1', '#00376E', '#CCD7E2'],
      cx: 80,
      cy: 80,
      radius: 60,
      strokeWidth: 25,
    };
  },
  computed: {
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    dataTotal() {
      return this.percentages.length
        ? this.percentages.reduce((acc, val) => acc + val) : 0;
    },
    values() {
      return this.labelsAndValues.map((labelAndValue) => labelAndValue[1]);
    },
    percentages() {
      const total = this.values.reduce((acc, val) => acc + val);
      return this.values.map((value) => 100 * (value / total));
    },
    labels() {
      return this.labelsAndValues.map((labelAndValue) => labelAndValue[0]);
    },
    percentagesPie() {
      // We want to show the slices in COUNTER clockwise direction...
      return [...this.percentages].reverse();
    },
    colorsPie() {
      // ... so we also need to reverse the color index in order to
      // match the color indexing of the labels.
      return [...this.colors].reverse();
    },

  },
  methods: {
    adjustedCircumference(value) {
      // "-1" for small gap between slices
      return value ? this.circumference - 1 : this.circumference;
    },
    calculateStrokeDashOffset(dataVal, circumference) {
      const sliceLength = this.dataPercentage(dataVal) * circumference * 0.5;
      // Note that stroke-dashoffset "pulls" the dash, so the offset effectively
      // specifies how much "empty" stroke we see.
      return circumference - sliceLength;
    },
    dataPercentage(dataVal) {
      return dataVal / this.dataTotal;
    },
    returnCircleTransformValue(index) {
      let percentOffset = 0;
      for (let i = 0; i < index; i += 1) {
        percentOffset += this.percentagesPie[i];
      }
      const degrees = this.angleOffset + 180 * (percentOffset / 100);
      return `rotate(${degrees}, ${this.cx}, ${this.cy})`;
    },
  },
};
</script>
